import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ROUTES } from '@/constants/routes';
import { PipeRatePredictionEditPage } from '@/features/pipe-predictions/PipeRatePredictionEditPage';
import { isPipeType } from '@/services/pipe-predictions-service';

function PipeRatePredictionRoute() {
  const { pipeType } = Route.useParams();
  if (!isPipeType(pipeType)) return <Navigate to={ROUTES.pipeRatePredictions} replace />;
  return <PipeRatePredictionEditPage pipeType={pipeType} />;
}

export const Route = createFileRoute('/admin/_app/pipe-rate-predictions/$pipeType')({
  component: PipeRatePredictionRoute,
});
